import './form/form-fields.component';
import './form/form-field.component';
import './form/location-lookup.directive';
export * from './register.component';
